module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 0
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///external "angular"